import React, { useEffect } from 'react';
import { ConnectedConfiguratorScreen } from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/Screen';
import SaveConfiguration from '../../Shared/Containers/SaveConfiguration';
import CustomThemeProvider from './ThemeProvider';
import CustomCreatorScreen from '../../Modules/Creator/CustomCreatorScreen';
import CustomDesignerScreen from '../../Modules/Designer/CustomDesignerScreen';
import AmountPrice from './Containers/AmountPrice';
import GlobalLoader from '../../Shared/Containers/GlobalLoader';
import SendEmail from '../../Shared/Containers/SendEmail';
import Progress from '../../Shared/Components/Progress/Progress';

export default (props) => (
  <ConnectedConfiguratorScreen
    {...props}
    ThemeProvider={CustomThemeProvider}
    CreatorScreen={CustomCreatorScreen}
    DesignerScreen={CustomDesignerScreen}
    renderAmountPrice={() => <AmountPrice />}
    renderSendEmail={() => <SendEmail />}
    renderLoader={() => <GlobalLoader />}
    renderSaveConfiguration={() => (
      <SaveConfiguration ProgressComponent={() => <Progress loading />} />
    )}
  />
);
